.logo {
  color: var(--color-primary);
  margin-bottom: 4rem;
}

.loginContainer {
  display: flex;
  min-height: 100vh;
  box-sizing: border-box;
}

.formContainer {
  display: flex;
  flex-direction: column;
  width: 606px;
  padding: 4rem 102px 4rem 120px;
  border-right: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.16));
  background: var(--static-background-standard, #fff);
  box-sizing: border-box;
}

.testimonialsContainer {
  flex: 1;
  background: linear-gradient(148deg, #cadfe3 0%, #cfdedb 100%);
  display: flex;
  flex-direction: column;
}

.backgroundImage {
  width: 100%;
  flex: 1;
  object-fit: none;
  object-position: center bottom;
}

@media screen and (max-width: 850px) {
  .formContainer {
    width: 100%;
    border-right-width: 0px;
    padding: 4rem;
  }
  .testimonialsContainer {
    display: none;
  }
}

@media screen and (max-width: 550px) {
  .formContainer {
    padding: 4rem 2rem;
  }
}